import sitecoreIds from 'src/app_config/sitecore-ids.json';

import { NavigationMenuItems } from 'src/components/global/Header/NavigationMenu';

export default function findMenuNestedItems(obj: NavigationMenuItems, url: string): { nestedItems: string | ''; active: boolean } {
	const nested = obj?.items?.find((item) => item.TemplateId === sitecoreIds.Templates.NavigationLinksTemplateId)?.items ?? [];

	const querystrings = nested.map((t) => t.Link?.value?.querystring).filter((qs): qs is string => typeof qs === 'string');

	const anchors = nested
		.filter(
			(t) =>
				t.items &&
				t.items.some(
					(item) => typeof item?.Link?.value?.href === 'string' && item.Link.value.href !== process.env.NEXT_PUBLIC_DEFAULT_SEARCH_PATH
				)
		)
		.flatMap((t) => t.items)
		.map((item) => item?.Link?.value?.href)
		.filter(
			(href): href is string => typeof href === 'string' && href.trim() !== '' && href !== process.env.NEXT_PUBLIC_DEFAULT_SEARCH_PATH
		);

	const texts = nested.map((t) => t.Link?.value?.text).filter((txt): txt is string => typeof txt === 'string');

	// Match by querystring
	const matchedQuery = querystrings.find((key) => url?.includes(key));

	if (matchedQuery) {
		return {
			nestedItems: matchedQuery,
			active: true,
		};
	}

	const matchedAnchor = anchors.find((key) => url?.includes(key));
	if (matchedAnchor) {
		return {
			nestedItems: matchedAnchor,
			active: true,
		};
	}

	const matchedText = texts.find((key) => url?.includes(key));
	if (matchedText) {
		return {
			nestedItems: matchedText,
			active: true,
		};
	}

	return {
		nestedItems: '',
		active: false,
	};
}
